import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoOperacoesDespesas: ['administracao'],
    removeRecursoOperacoesDespesas: ['recurso'],
    removeDestinacaoOperacoesDespesas: ['destinacao'],
    removeTipoRecursoOperacoesDespesas: ['tipoRecurso'],
    setMostraAplicarFiltroOperacoesDespesas: [],
    limpaFiltroOperacoesDespesas: [],
    aplicarFiltroOperacoesDespesas: ['filtro'],
})

const INITIAL_STATE = {
    administracoes: [],
    recursos: [],
    destinacoes: [],
    tipoRecursos: [],
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracoes.splice(state.administracoes.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracoes = Array.from(state.administracoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recursos.splice(state.recursos.indexOf(action.recurso), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.recursos = Array.from(state.recursos)
    return { ...state, mostraAplicarFiltro: true }
}

const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacoes.splice(state.destinacoes.indexOf(action.destinacao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.destinacoes = Array.from(state.destinacoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeTipoRecurso = (state = INITIAL_STATE, action) => {
    state.tipoRecursos.splice(state.tipoRecursos.indexOf(action.tipoRecurso), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.tipoRecursos = Array.from(state.tipoRecursos)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_OPERACOES_DESPESAS]: removeAdministracao,
    [Types.REMOVE_RECURSO_OPERACOES_DESPESAS]: removeRecurso,
    [Types.REMOVE_DESTINACAO_OPERACOES_DESPESAS]: removeDestinacao,
    [Types.REMOVE_TIPO_RECURSO_OPERACOES_DESPESAS]: removeTipoRecurso,
    [Types.SET_MOSTRA_APLICAR_FILTRO_OPERACOES_DESPESAS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_OPERACOES_DESPESAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_OPERACOES_DESPESAS]: aplicarFiltro,
})
